import { Typography } from '@mui/material'

const IformBreadcrumb = ({ onClick, children }) => {
  return (
    <Typography
      onClick={onClick}
      type='body'
      size='medium'
      weight='bold'
      sx={{
        fontSize: '18px',
        color: '#007BC2',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
          color: '#003CA5',
        },
      }}>
      {children}
    </Typography>
  )
}

export default IformBreadcrumb
